import { useEffect, useState } from "react";
import config from "../../../config";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import { CustomContainer, Modal } from "../../atoms/DependencyHelper";
import labels from "../../../config/labels";
import * as Analytics from "../../../services/analyticsUtag";
import styles from "./UpgradeFiltersModal.module.scss";

const UpgradeFiltersModal = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const [displayCategory, setDisplayCategory] = useState(true);
  const [selectedCategory, setSelectedCategory]=useState();
  const [subCatgeory,setSubCategory]= useState([]);
  const [selectedBrand, setSelectedBrand] = useState(props.selectedBrand);
  const [selectedModel, setSelectedModel] = useState(props.selectedModel);
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [isReset, setIsReset] = useState(false);

  useEffect(() => {
    setSelectedBrand(props.selectedBrand);
  }, [props.selectedBrand])

  useEffect(() => {
    setSelectedModel(props.selectedModel);
  }, [props.selectedModel])

  useEffect(() => {
    if(isReset) {
      props.applyFilters();
      setIsReset(false);
    }
  },[isReset])

  const handleResetAll = () => {
    props.setSelectedBrand();
    props.setSelectedModel();
    props.setSelectedContractType("");
    setSelectedBrand();
    setSelectedModel();
    setSelectedSubCategory();
    props.setContractTypeFilterApplied(false);
    props.setBrandFilterApplied(false);
    props.setModelFilterApplied(false);
    setIsReset(true);
  };

  const handleCategory = (item) => {
    setSelectedCategory(item.name);
    setDisplayCategory(false);
    switch (item.name) {
      case "Brands":
        let sortedBrands = props.brands.sort((a, b) => a.localeCompare(b));
        setSubCategory(sortedBrands ? sortedBrands : props.brands);
        break;
      case "Models":
        setSubCategory(props.models)
        break;
      default:
        setSubCategory(props.planData);
        break;
    }
  };

  const handleBackbtn=()=> {
    setDisplayCategory(true);
    setSelectedBrand();
    setSelectedModel();
    setSelectedSubCategory();
  }

  const handleSelections = (item,type)=> {
    let selArray;

    switch (type=="category"?item.name:item) {
      case labels.upgrade.planData.lbl_looking_for:
        selArray = props.selectedContractType;
        break;
      case "Brands":
        selArray = selectedBrand ? selectedBrand : props.selectedBrand;
        break;
      case "Models":
        selArray = selectedModel ? selectedModel : props.selectedModel;
        break;
      default:
        selArray = "";
        break;
    }

    return selArray;
  }

  const handleSubCategory = (item) => {
    switch (selectedCategory) {
      case labels.upgrade.planData.lbl_looking_for:
        if (item===labels.upgrade.planData.lbl_contract_sim_only) {
          props.setSelectedModel();
          props.setSelectedBrand();
          setSelectedBrand();
          setSelectedModel();
        }
        props.setSelectedContractType(item);
        setDisplayCategory(true);
        setSelectedSubCategory("contractType");
        break;
      case "Brands":
        setSelectedSubCategory("brands");
        setSelectedBrand(item);
        break;
      case "Models":
        setSelectedSubCategory("models");
        setSelectedModel(item);
        break;
      default:
        break;
    }
    Analytics.link({
      ...Analytics.getUtagData([
        "visitor_customer_id",
        "visitor_login_status",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
        "visitor_msisdn_hash",
        "page_name",
        "page_channel",
        "page_master_tab",
        "upgrade_eligibility_status",
        "upgrade_ineligible_reason",
        "upgrade_eligible_date",
        "upgrade_customer_type",
      ]),
      filter_query: item,
      page_tool_event: "use",
      page_tool_name: `${Analytics.getPageName()}: ${selectedCategory} filter`,
    })
  };

  const checkDisplay = () => {
    props.setShowModal(false);
    setDisplayCategory(true);
  };

  const handleFilters= ()=> {
    if(displayCategory) {
      //apply filters
      props.applyFilters();
      props.setShowModal(false);
      props.setContractTypeFilterApplied(true);
      props.setBrandFilterApplied(true);
      props.setModelFilterApplied(true);
    } else {
      //save selections
      switch(selectedSubCategory) {
        case "brands":
          props.setSelectedBrand(selectedBrand);
          break;
        case "models":
          props.setSelectedModel(selectedModel);
          break;
        default:
          break;
      }
      setDisplayCategory(true);
    }
  }

  const handleReset = () => {
    switch(selectedSubCategory) {
      case "contractType":
        props.setSelectedContractType("");
        props.setSelectedBrand();
        props.setSelectedModel();
        break;
      case "brands":
        props.setSelectedBrand();
        setSelectedBrand();
        break;
      case "models":
        props.setSelectedModel();
        setSelectedModel();
        break;
      default:
        break;
    }
    setIsReset(true);
  }

  const isContractSelected = () => {
    return !!props?.selectedContractType;
  }

  const handleDisableButton =()=> {
   if ((selectedBrand || selectedModel || props.selectedBrand || props.selectedModel || props.selectedContractType===labels.upgrade.planData.lbl_contract_sim_only) && isContractSelected()) {
      return false;
    } else {
      return true;
    }
  }

  const handleDisableItem =(item)=> {
    return (props.selectedContractType === labels.upgrade.planData.lbl_contract_sim_only && item.name!==labels.upgrade.planData.lbl_looking_for)
      || (item.name=="Brands" && !isContractSelected())
      || (item.name=="Models" && !props.selectedBrand);
  }

  const categoriesList = [
    {
      id: 1,
      name: labels.upgrade.planData.lbl_looking_for,
    },
    {
      id: 2,
      name: "Brands",
    },
    {
      id: 3,
      name: "Models",
    },
  ];

  const Categories = () => {
    return (
      <CustomContainer>
        <div className={styles["buttons-section"]}>
          <button
            className={`${styles["button"]}`}
            onClick={checkDisplay}
            id="backbtn-nav-bundlepage"
          >
            <img
              className="Arrow_icon-arrow__JlciI"
              src={`${imagePrefix}/assets/images/icon-arrow-left.svg`}
            />
          </button>
          <span className={styles["category-title"]} id="filter-bundle-title">
            {"Filters"}
          </span>
          <button
            className={`${styles["button"]} ${styles["reset"]}`}
            onClick={handleResetAll}
            id="reset-nav-bundlepage"
          >
            Reset All
          </button>
        </div>
        {categoriesList &&
        categoriesList.map((item) => (
          <CustomContainer className={`${styles["category-container"]} ${handleSelections(item,"category")? "py-m" : "py-l"}`}>

            <CustomContainer
              className={`${styles["category"]} ${handleDisableItem(item)?styles["disabled"] :""}`}
              onClick={() => handleCategory(item)}
            >
              {item.name}
              <i className={`v-icon-chevron-right ${styles["arrow"]} ${handleSelections(item,"category")?styles["selection_for"]:""} ${item.id == 1?styles["looking_for"]:""}`}></i>
            </CustomContainer>
            <div
              className={`${
                styles["selected-values"]
              }`}
            >
              <div className={`sub-item ${handleSelections(item,"category") && styles["selected-values__label"]}`}>
                {handleSelections(item,"category")}
              </div>
            </div>
          </CustomContainer>
        ))}
        
      </CustomContainer>
    );
  };

  const SubCategories = () => {
    return (
      <CustomContainer>
        <div className={styles["buttons-section"]}>
          <button
            className={`${styles["button"]}`}
            onClick={handleBackbtn}
            id="backbtn-nav-bundlepage"
          >
            <img
              className="Arrow_icon-arrow__JlciI"
              src={`${imagePrefix}/assets/images/icon-arrow-left.svg`}
            />
          </button>
          <span className={styles["category-title"]} id="filter-bundle-title">
            {"Filters"}
          </span>
          <button
            className={`${styles["button"]} ${styles["reset"]}`}
            onClick={handleReset}
            id="reset-nav-bundlepage"
          >
            Reset
          </button>
        </div>
        {subCatgeory && subCatgeory.map((item)=>(
          <CustomContainer className={`${styles["sub-category"] } ${handleSelections(selectedCategory,"subcategory")==item && styles["active-option"]}`} onClick={() => handleSubCategory(item)}>
            {item}
          </CustomContainer>
        ))
        }
      </CustomContainer>
    );
  };

  const FilterFooter = () => {
    return (
      <>
        {(displayCategory || selectedCategory != labels.upgrade.planData.lbl_looking_for) && (
          <CustomContainer className={`${styles["show-results"]} ${handleDisableButton() ? styles["disabled"]:""}`}>
            <button
              className={displayCategory 
                          ? styles["show-results__button"]
                          : styles["show-results__save-selection"]
                        }
              onClick={handleFilters}
            >
              {displayCategory
                ? "Apply filters"
                : labels.lbl_save_selection
              }
            </button>
          </CustomContainer>
        )}
      </>
    );
  }

  return (
    <CustomContainer>
      <Modal
        show={props.showModal}
        onHide={checkDisplay}
        dialogClassName={"select-modal"}
      >
        {displayCategory ? <Categories /> : <SubCategories />}
        <FilterFooter />
      </Modal>
    </CustomContainer>
  );
};

export default UpgradeFiltersModal;

